import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DateUtil } from 'src/app/common/util';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { CompanyRequest, CompanyScheduleRequest, NewCompanyRequest } from 'src/app/models/company.model';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';
import { CompanyService } from 'src/app/services/company.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';

@Component({
  selector: 'app-modal-company-request',
  templateUrl: './modal-company-request.component.html',
  styleUrls: ['./modal-company-request.component.scss']
})
export class ModalCompanyRequestComponent implements OnInit {
  newCompany: CompanyRequest = new CompanyRequest();
  newCompanyRequest: NewCompanyRequest = new NewCompanyRequest();
  schedules: CompanyScheduleRequest[] = [];
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  @Output() close = new EventEmitter<any>();
  lat = null;
  lng = null;
  photos: string[] = [];
  tempDate: string = "";
  users = [];
  timeout = null;
  inputs = new InputAutocompleteModel("", false, true, "", "fa-asterisk", "", "", null, []);

  constructor(
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private companyService: CompanyService
  ) {
    this.tempDate = DateUtil.getActualDate();
    this.setDate(this.tempDate);
  }

  searchUser() {
    clearTimeout(this.timeout);
    if (this.inputs.value.length > 4) {
      this.inputs.class = "typing";
      this.timeout = setTimeout(() => {
        this.companyService.getAllUsers(this.inputs.value).subscribe({
          next: (response: ResponseObject) => {
            this.users = response.data;
            if (this.users.length == 0) {
              this.inputs.class = "fa-xmark";
            } else {
              this.inputs.class = "fa-list";
            }
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
          }
        })
      }, 500);
    }
  }

  selectUser(user) {
    this.inputs.value = user.email;
    this.inputs.verified = true;
    this.inputs.class = "fa-circle-check";
    this.inputs.data = user;
    this.newCompanyRequest.userId = user.id;
  }

  seeDate(
    event
  ) {
    this.setDate(event.target.value);
  }

  setDate(date) {
    if (date) {
      this.newCompanyRequest.date = DateUtil.parseToMilliDateTime(date);
    }
  }

  onFileChange(event: Event, fileInput: HTMLInputElement): void {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    const files = Array.from(input.files);
    let filesProcessed = 0;
    files.forEach(file => {
      this.convertToBase64(file, () => {
        filesProcessed++;
        if (filesProcessed === files.length) {
          // Clear the file input after all files are processed
          fileInput.value = '';
        }
      });
    });
  }

  convertToBase64(file: File, callback: () => void): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.result) {
        this.photos.push(reader.result as string);
      }
      callback();
    };
    reader.onerror = (error) => {
      console.error('Error converting file to base64: ', error);
      callback();
    };
  }

  ngOnInit(): void {
    this.getUserLocation();
  }

  getUserLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        console.log(this.lat, this.lng);
      }, () => {
        this.toastService.info("Activa la locación para poder guardar la solicitud");
      }, { timeout: 10000 });
    } else {
      this.toastService.info("La locación es necesaria para guardar la solicitud");
    }
  }

  getDisabledGeneral() {
    if (!this.newCompany.name
      || !this.newCompany.nit
      || !this.newCompany.address
      || !this.newCompany.mail
      || !this.newCompany.town
    )
      return true;
  }

  saveRequest() {
    if (this.buttonSave.loading) {
      return;
    }
    this.buttonSave.loading = true;
    this.newCompanyRequest.companyData = this.newCompany;
    this.newCompanyRequest.photos = this.photos;
    this.newCompanyRequest.geolocation = this.lat + "," + this.lng;
    this.companyService.saveCompanyRequest(this.newCompanyRequest).subscribe({
      next: (response: ResponseObject) => {
        this.buttonSave.loading = false;
        console.log(response);
      },
      error: (error: HttpErrorResponse) => {
        this.buttonSave.loading = false;
        this.toastService.error(error.error.message);
      }
    })
  }
}
